<template>
  <!-- 面包屑 -->
  <a-breadcrumb>
    <a-breadcrumb-item>自媒体管理</a-breadcrumb-item>
    <a-breadcrumb-item>音色库</a-breadcrumb-item>
  </a-breadcrumb>
  <!-- 功能条 -->
  <div class="tool-view">
    <div style="flex: 1;"></div>
    <a-button type="primary" @click="touchEdit()"><plus-outlined />新建音色</a-button>
  </div>
  <!-- 列表 -->
  <a-table
    class="table-view"
    :data-source="dataSource"
    :columns="columns"
    :row-key="record => record.id"
    :pagination="pagination"
    :loading="isLoading"
    @change="handleTableChange"
  >
    <template #bodyCell="{ column, record }">
      <template v-if="column.key === 'operation'">
        <a class="operation-item" @click="touchPreview(record)">{{ playingUrl === record.url ? '停止' : '试听' }}</a>
        <a class="operation-item" @click="touchEdit(record)">编辑</a>
        <a-popconfirm
          title="确定要删除吗？"
          @confirm="touchDelete(record)"
        >
          <a class="operation-item">删除</a>
        </a-popconfirm>
      </template>
    </template>
  </a-table>
  <!-- 新建、编辑音色 -->
  <TimbreAdd ref="RefTimbreAdd" @success="getList"></TimbreAdd>
</template>

<script setup>
import { onBeforeMount, ref, reactive } from 'vue'
import { PlusOutlined } from '@ant-design/icons-vue'
import TimbreAdd from './components-timbre/Add'
import { message } from 'ant-design-vue'
import { speechList, speechDelete } from '@/api/admin'

let RefTimbreAdd = ref(null)
let isLoading = ref(false)
let dataSource = ref([])
let audioInstance = ref(null)
let playingUrl = ref(null)
let pagination = reactive({
  total: 0,
  current: 1,
  pageSize: 10,
  showSizeChanger: true
})
let columns = ref([
  {
    title: '火山音色ID',
    dataIndex: 'speech_voice_hs',
    key: 'speech_voice_hs'
  },
  {
    title: '音色名称',
    dataIndex: 'name',
    key: 'name'
  },
  {
    title: '原语种',
    dataIndex: 'source_lang_name',
    key: 'source_lang_name'
  },
  {
    title: '目标语种',
    dataIndex: 'target_lang_name',
    key: 'target_lang_name'
  },
  {
    title: '创建人',
    dataIndex: 'admin_name',
    key: 'admin_name'
  },
  {
    title: '创建日期',
    dataIndex: 'created_date',
    key: 'created_date'
  },
  {
    title: '操作',
    dataIndex: 'operation',
    key: 'operation'
  }
])

onBeforeMount(() => {
  getList()
})

function getList () {
  isLoading.value = true
  const params = {
    page: pagination.current,
    page_size: pagination.pageSize
  }
  speechList(params).then(res => {
    isLoading.value = false
    const { code, data, message: resMsg } = res
    if (code === 0) {
      dataSource.value = data.data || []
      pagination.current = data.current_page || pagination.current
      pagination.total = data.total ?? 0
    } else {
      message.error(res.message || resMsg || '请求失败')
    }
  })
}

function handleTableChange (p, filters, sorter) {
  pagination.current = p.current
  pagination.pageSize = p.pageSize
  getList()
}

function previewStop () {
  if (audioInstance.value) {
    audioInstance.value.pause()
    audioInstance.value.currentTime = 0
    audioInstance.value = null
  }
  playingUrl.value = null
}

function touchPreview (record) {
  const url = record?.url
  if (!url) {
    message.warning('暂无试听地址')
    return
  }
  if (playingUrl.value === url) {
    previewStop()
    return
  }
  previewStop()
  const audio = new Audio(url)
  audioInstance.value = audio
  playingUrl.value = url
  audio.play().catch(() => {
    message.warning('播放失败')
    playingUrl.value = null
    audioInstance.value = null
  })
  audio.onended = () => {
    playingUrl.value = null
    audioInstance.value = null
  }
}

function touchEdit (record) {
  RefTimbreAdd.value.showModal(record || {})
}

function touchDelete (record) {
  speechDelete({ id: record.id }).then(res => {
    const { code, msg } = res
    if (code === 0) {
      message.success('操作成功')
      getList()
    } else {
      message.error(res.message || msg)
    }
  })
}
</script>

<style scoped>
.tool-view {
  display: flex;
  align-items: center;
  margin-top: 20px;
}
.table-view {
  margin-top: 20px;
}
.operation-item {
  margin-right: 16px;
}
</style>
